import Rest from '../../Rest'

export default class LegalEntityFormDueDiligenceService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/due_diligence_form_config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
